import React from 'react';

import { Surface } from '@infoods/lifebase-ui';
import classNames from 'classnames';

import classes from './NutrientInfoBlock.module.scss';
import { GridTableRow } from '../../../../shared/components/table-components';
import { NutrientInfoGroup } from './NutrientInfoGroup/NutrientInfoGroup';
import { useTotalSugar } from '../../../hooks/meal-plan-macros';

type NutrientInfoBlockProps = {
  nameIndex: number;
  className?: string;
};

const NutrientInfoBlock = ({ nameIndex, className }: NutrientInfoBlockProps) => {
  useTotalSugar(nameIndex);

  return (
    <Surface className={classNames(classes.nutrientTable, className)}>
      <GridTableRow variant="subRow">
        <NutrientInfoGroup
          label="Sugar per day"
          name={`mealPlans.${nameIndex}.sugarTotal`}
          nutrient="sugar"
        />
        <NutrientInfoGroup
          label="Sodium per day (mg)"
          name={`mealPlans.${nameIndex}.sodiumTotal`}
          nutrient="sodium"
        />
      </GridTableRow>
      <GridTableRow variant="subRow">
        <NutrientInfoGroup
          label="Fiber per meal"
          name={`mealPlans.${nameIndex}.fiberPerMeal`}
          nutrient="fiber"
        />
        <NutrientInfoGroup
          label="Vegetables per day (cups)"
          name={`mealPlans.${nameIndex}.cupsVeggies`}
          nutrient="veggies"
        />
      </GridTableRow>
    </Surface>
  );
};

export { NutrientInfoBlock };
